<template>
  <Drawer placement="left" :closable="false" v-model="openPoint" width="280" draggable class="my-drawer" title="标注点">
    <div id="pointList">
      <ly-search v-model="keyword" placeholder="请输入关键字" @search="getList"></ly-search>

      <ul>
        <li @click="clickItem(item)" v-for="(item, index) in tableData" :key="index" :class="{ active: item.select }">
          <div>
            {{ item.name }}
          </div>
          <div>
            <Icon title="编辑" @click.stop="opemUpdate(item)" class="icon" type="md-checkmark-circle-outline" />
            <Icon title="删除" @click.stop="del(item)" class="icon" type="md-close" />
          </div>
        </li>
      </ul>

      <Row :gutter="10">
        <Col span="12">
        <Button long @click="checkAll" type="primary">{{
          isAll ? "取消选择" : "选择全部"
        }}</Button></Col>
        <Col span="12">
        <Button long @click="openAdd" type="success">新增</Button></Col>
      </Row>
    </div>
    <point ref="point" v-if="openOut" @ok="open" :outUse="true"></point>
  </Drawer>
</template>
<script>
import point from "../rule/rulePoint.vue";
export default {
  components: { point },
  data() {
    return {
      openPoint: false,
      openOut: false,
      tableData: [],
      selectData: [],
      isAll: false,
      isAdd: true,
      keyword: "",
      item: {
        cs: 2,
        name: "",
        radius: 50,
        x: 0,
        y: 0,
        remark: "",
        type: "",
        address: "",
      },
      forms: [
        {
          title: "名称",
          key: "name",
          type: "Input",
          required: true,
          span: 6,
          sort: 2,
        },
        {
          title: "半径/米",
          key: "radius",
          type: "Select",
          selectItems: [20, 50, 100, 200, 500, 1000],
          required: true,
          span: 4,
          sort: 2,
        },
        {
          title: "备注信息",
          key: "remark",
          type: "Input",
          required: false,
          span: 6,
          sort: 2,
        },
        {
          title: "详细地址",
          key: "address",
          slotForm: "address",
          required: false,
          span: 7,
          sort: 2,
        },
      ],
    };
  },
  methods: {
    open() {
      this.openPoint = true;
      this.openOut = false;
      this.getList();
    },
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.rule + "/marker/list",
        data: { keyword: this.keyword },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        var arr = [];
        var arrid = [];
        for (const i in this.tableData) {
          if (this.tableData[i].select) {
            arr.push(this.tableData[i]);
            arrid.push(this.tableData[i].id);
          }
        }
        this.tableData = arr;
        for (let i = 0; i < data.length; i++) {

          if (!arrid.includes(data[i].id)) {
            data[i].select = false;
            this.tableData.push(data[i]);
          }
        }
      });
    },
    push() {
      this.selectData = []; //为了应付郑平客户。先注释这一行
      for (let i = 0; i < this.tableData.length; i++) {

        if (this.tableData[i].select) {
          this.selectData.push(this.tableData[i]);
        }
      }

      var x = this.selectData.length;
      if (x > 0) {
        this.isAll = true;
      } else {
        this.isAll = false;
      }
      this.$emit("points", this.selectData);
    },
    clickItem(v) {
      v.select = !v.select;
      this.push();
    },
    checkAll() {
      this.isAll = !this.isAll;
      var m = this.tableData.length;
      var num = 2000;
      var list = m > num ? num : m;
      this.selectData.length = 0;

      if (this.isAll) {
        for (let i = 0; i < list; i++) {
          this.tableData[i].select = this.isAll;
          this.selectData.push(this.tableData[i]);
        }
      } else {
        for (let i = 0; i < m; i++) {
          this.tableData[i].select = this.isAll;
        }
      }

      this.$emit("points", this.selectData);
    },

    //删除公司
    del(row, n) {
      if (row.select) {
        this.clickItem(row);
      }
      this.openPoint = false;
      this.openOut = true;
      setTimeout(() => {
        this.$refs.point.del(row);
      }, 200);
    },
    //点击编辑按钮
    opemUpdate(row) {
      if (row.select) {
        this.clickItem(row);
      }
      this.isAdd = false;
      this.openPoint = false;
      this.openOut = true;
      setTimeout(() => {
        this.$refs.point.opemUpdate(row);
      }, 200);
    },
    openAdd() {
      this.isAdd = true;
      this.openPoint = false;
      this.openOut = true;
      setTimeout(() => {
        this.$refs.point.openAdd();
      }, 200);
    },
  },
};
</script>
<style lang="">
#pointList {
  height: 100%;
}
#pointList ul {
  height: calc(100% - 80px);
  margin: 10px auto;
  overflow: auto;
}
#pointList li {
  padding: 10px;
  cursor: pointer;
  display: flex;
}
#pointList li.active {
  background: #d9ebfe;
}
#pointList li div:first-child {
  width: calc(100% - 40px);
}
#pointList li div:last-child {
  width: 40px;
}
#pointList li div:last-child .icon {
  font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/pointList.vue